import { OptionType } from 'ui/components/Select/types';

export function setFiltersToLocalStorage<T>(pageLocation: string, label: string, value?: T): void {
  const localStorageFilters: Record<string, OptionType> | null =
    getDataFromLocalStorage(pageLocation);

  const newLocalStorageFilters = localStorageFilters
    ? { ...localStorageFilters, [label]: value }
    : { [label]: value };

  const stringifyValue = JSON.stringify(newLocalStorageFilters);

  localStorage.setItem(pageLocation, stringifyValue);
}

export function getDataFromLocalStorage<T>(label: string): T | null {
  const stringifyValue = localStorage.getItem(label);
  return stringifyValue ? JSON.parse(stringifyValue) : null;
}

export const setLocalStorage = (key: string, value: string | null) => {
  if (!value) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
};
